// @ts-nocheck

import { Component, OnInit } from '@angular/core';
import { Balance, BalancesAndTotal } from '../model';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { map } from 'rxjs/operators';
import { AngularFireAuth } from 'angularfire2/auth';
import { setTimeoutNonBlocking } from '@firebase/database/dist/esm/src/core/util/util';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  balances: Observable<Balance[]>
  total: Observable<number>
  userId: String
  noPassword: Observable<boolean>
  offline = false

  constructor(public db: AngularFireDatabase, public auth: AngularFireAuth) {
  }

  ngOnInit() {
    this.userId = this.auth.auth.currentUser.uid;

    this.balances = combineLatest(
      this.db.object("balances/" + this.userId).valueChanges(),
      this.db.object("averageRatesInUsd/latest").valueChanges(),
      (balances, rates) => {
        return [
          new Balance("HEK", "Hayek Coin", balances["HEK"], rates["HEK"]),
          new Balance("TBR", "Rothbard Coin", balances["TBR"], rates["TBR"]),
          new Balance("RND", "Rand Coin", balances["RND"], rates["RND"])
        ]
      }
    )
    this.total = this.balances.map(balances =>
      balances.map(balance => this.valueInUsd(balance))
        .reduce((sum, current) => sum + current)
    )
    this.noPassword = this.db.object("users/" + this.userId + "/password").valueChanges().map(
      password => (password == null || password == "")
    );
    setTimeout(() => {
      this.db.object(".info/connected").valueChanges().subscribe(
        value => {
          this.offline = value != null && value == false
        }
      )
    }, 1000)
  }

  valueInUsd(balance: Balance) {
    return balance.amount * balance.exchangeRateToUsd
  }

  abbrClicked(balance: Balance) {
    alert(balance.coinCode + " = " + balance.coinName)
  }

  protectClicked() {
    /*
    var sha256 = function(password, salt){
      var hash = crypto.createHmac('sha256', salt); /** Hashing algorithm sha512
      hash.update(password);
      var value = hash.digest('hex');
      return {
        salt:salt,
        passwordHash:value
      };
    }; */

    var password = prompt("Anyone can access your coins if they get private key from your badge. Add a password to protect it:")
    if (password != null) {
      this.db.object("users/" + this.userId).update({ password: password })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts